import * as api from '../requests'
import store, { history } from '../store'
import ls from 'local-storage'
import shortid from 'shortid'
import { resetFullAppState, getAndSetCartQuantity } from '../actions'

/// #if useOkta === true
const { oktaFunctions } = require('../components/Okta/OktaLogin')
const { oktaRefreshTokens } = require('../components/Okta/oktaRefreshTokens')
/// #endif

export const loginWebUser = (credentials, callback) => (dispatch) => {
  api.LOGIN_WEB_USER(
    credentials,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch)
      dispatch(getAndSetCartQuantity())
      // dispatch(registerAuthPoll())
      callback(true)
    },
    (err) => {
      // if(err.code === 'auth/invalidLogin')
      callback(
        false,
        err.message || 'The username or password you provided was incorrect. Please try again.'
      )
    }
  )
}

export const storeAndDispatchLoginResponse = (response, dispatch) => {
  let webUser = response.Item1
  let webUserAuthentication = response.Item2
  // if(process.env.NODE_ENV !== 'test'){console.log(response)}
  localStorage.setItem('WEB_USER', JSON.stringify(webUser))
  localStorage.setItem('WEB_USER_AUTHENTICATION', JSON.stringify(webUserAuthentication))
  localStorage.setItem('LAST_USERS_GROUP', JSON.stringify(getUserGroup[webUser.USER_TYPE_ID]))
  const loginObj = {
    initialAuthCheck: false,
    FIRST_NAME: webUser.FIRST_NAME,
    MIDDLE_NAME: webUser.MIDDLE_NAME,
    LAST_NAME: webUser.LAST_NAME,
    ORG_NAME: webUser.ORG_NAME,
    BUSINESS_NAME: webUser.BUSINESS_NAME,
    WEB_USER_ID: webUser.WEB_USER_ID,
    USERNAME: webUser.USERNAME,
    EMAIL: webUser.EMAIL,
    ADDR1: webUser.ADDR1,
    ADDR2: webUser.ADDR2,
    ADDR3: webUser.ADDR3,
    CITY: webUser.CITY,
    STATE: webUser.STATE,
    POSTAL_CODE: webUser.POSTAL_CODE,
    COUNTRY: webUser.COUNTRY,
    USER_GROUP: getUserGroup[webUser.USER_TYPE_ID],
    isFrequentPayor: webUser.IS_FREQUENT_PAYOR_YN,
    loggedIn: true,
    trigger: shortid.generate(),
    PHONE: webUser.PHONE,
  }
  dispatch(spreadAuthAttributes(loginObj))
  const cachedCategory = getCategoryCache(webUser.WEB_USER_ID)
  if (cachedCategory) {
    dispatch({ type: 'SET_CURRENT_CATEGORY', category: cachedCategory })
  }
  dispatch(getAndSetCartQuantity())
  ls.set('EVENT_LOGIN', loginObj)
}

const getCategoryCache = (WEB_USER_ID) => {
  const userCache = ls.get('USER_CACHE')
  if (userCache) {
    return userCache[WEB_USER_ID]
  }
}

export const getUserGroup = {
  0: 'PUBLIC',
  1: 'WEB',
  2: 'ADMIN',
  3: 'ADMIN_WEB',
  4: 'ADMIN_RO',
}

export const spreadAuthAttributes = (payload) => ({
  type: 'SPREAD_AUTH_ATTRIBUTES',
  payload,
})

export const setAuthAttribute = (attribute, value) => ({
  type: 'SET_AUTH_ATTRIBUTE',
  attribute,
  value,
})

export const AUTH_EXTEND_THRESHOLD_MS = 5 * 60 * 1000

export const getAuthState = (callback) => (dispatch, getState) => {
  dispatch(setAuthAttribute('checkingAuthState', true))
  let WEB_USER = localStorage.getItem('WEB_USER')
  let webUser = WEB_USER && WEB_USER !== 'undefined' ? JSON.parse(WEB_USER) : {}
  api.GET_AUTH_STATE(
    (response) => {
      if (response !== false && response !== 'false') {
        if (callback) {
          callback(true, dispatch)
        }
        const authObj = {
          ...response.VALUE,
          checkingAuthState: false,
          loggedIn: true,
          FIRST_NAME: webUser.FIRST_NAME,
          MIDDLE_NAME: webUser.MIDDLE_NAME,
          LAST_NAME: webUser.LAST_NAME,
          BUSINESS_NAME: webUser.BUSINESS_NAME,
          WEB_USER_ID: webUser.WEB_USER_ID,
          USER_GROUP: getUserGroup[webUser.USER_TYPE_ID],
          USERNAME: webUser.USERNAME,
          PHONE: webUser.PHONE,
          isFrequentPayor: webUser.IS_FREQUENT_PAYOR_YN,
          initialAuthCheck: false,
          trigger: shortid.generate(),
        }
        dispatch(spreadAuthAttributes(authObj))
        let location = getState().router.location
        if (location.pathname === '/auth' || location.pathname === '/admin') {
          const from = location.search
            ? new RegExp(/from=(.*?)(&|$)/g).exec(location.search) || []
            : '/'
          const search = location.search
            ? new RegExp(/search=(.*?)$/g).exec(location.search) || []
            : '/'
          history.replace(`${from[1] || ''}${search[1] || ''}`)
        }
        // dispatch(registerAuthPoll())
        ls.set('EVENT_LOGIN', authObj)
        if (process.env.SHOPPING_CART) {
          dispatch(getAndSetCartQuantity())
        }
      } else {
        if (callback) {
          callback(false, dispatch)
        }
        dispatch(
          spreadAuthAttributes({
            checkingAuthState: false,
            initialAuthCheck: false,
            loggedIn: false,
          })
        )
        dispatch(clearUser())
        // unregisterAuthPoll()
      }
    },
    (err) => {
      dispatch(
        spreadAuthAttributes({
          checkingAuthState: false,
          initialAuthCheck: false,
          loggedIn: false,
        })
      )
      dispatch(clearUser())
    }
  )
}

export const registerAuthPoll = () => (dispatch) => {
  if (!window.AUTH_POLL) {
    window.AUTH_POLL = setInterval(() => {
      dispatch(getAuthState())
    }, 60000)
  }
}

export const unregisterAuthPoll = () => {
  clearInterval(window.AUTH_POLL)
  delete window.AUTH_POLL
}

export const clearUser = () => ({
  type: 'CLEAR_USER',
})

export const logoutWebUser = (broadcast) => (dispatch) => {
  if (process.env.RETURN_TO_HOME_ON_LOGOUT) {
    history.push('/')
  }
  api.LOGOUT_WEB_USER((response) => {
    if (response === true) {
      clearLocalUser(broadcast)
      detachEventCheck()
      ls.set('EVENT_LOGOUT', shortid.generate())
      if (process.env.LOGIN_REDIRECTS_TO_EPASS) {
        logoutEpassUser()
      }
      // unregisterAuthPoll()
    }
  })
}

export const logoutEpassUser = () => {
  window.location.href = `${api.BASE_URL}/api/Logout.epass`
}

export const clearLocalUser = (broadcast) => {
  window.ALLOW_BYPASS_WIZARD_PROMPT = true
  localStorage.removeItem('WEB_USER')
  localStorage.removeItem('WEB_USER_AUTHENTICATION')
  localStorage.setItem('AUTH_TIMER', 0)
  /// #if useOkta === true
  if (process.env.HAS_OKTA_LOGIN) {
    const userIsLoggedIn = store.getState().auth.loggedIn
    if (userIsLoggedIn) {
      localStorage.removeItem('OKTA_RETURN_URL')
      oktaFunctions.logout()
    }
  }
  /// #endif
  if (process.env.HAS_ACTIVE_DIRECTORY_LOGIN) {
    const userIsLoggedIn = store.getState().auth.loggedIn
    if (userIsLoggedIn) {
      localStorage.removeItem('ACTIVE_DIRECTORY_RETURN_URL')
      history.replace("/")
    }
  }
  clearLocalUserState()
  if (broadcast) {
    ls.set('EVENT_LOGOUT', shortid.generate())
  }
  window.ALLOW_BYPASS_WIZARD_PROMPT = false
}

const clearLocalUserState = () => {
  clearTimeout(window.AUTH_TIMER)
  window.AUTH_TIMER = null
  clearTimeout(window.EVENT_CHECK_TIMER)
  window.EVENT_CHECK_TIMER = null
  store.dispatch(clearUser())
  store.dispatch(resetFullAppState())
}

export const loginAppUser = (credentials, callback) => (dispatch) => {
  api.LOGIN_APP_USER(
    credentials,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch)
      dispatch(getAndSetCartQuantity())
      callback(true)
    },
    (err) => {
      callback(false, err.message || 'Invalid Login')
    }
  )
}

export const setExpiration = (expires) => ({
  type: 'SET_EXPIRATION',
  expires,
})

export const setAuthTimeoutExpiresAt = (authTimeoutExpiresAt) => ({
  type: 'SET_AUTH_TIMEOUT_EXPIRES_AT',
  authTimeoutExpiresAt,
})

let _extendInFlight = false

export const extendUserSession = () => (dispatch) => {
  if (_extendInFlight) return
  _extendInFlight = true
  const release = () => { _extendInFlight = false }
  setTimeout(release, 15000)
  dispatch(setExpiration(null))
  /// #if useOkta === true
  let staleToken = ls.get('WEB_USER_AUTHENTICATION')
  oktaRefreshTokens()
    .then(() => {
      api.EXTEND_WEB_USER_SESSION(staleToken.ID, release)
    })
    .catch(release)
  /// #endif
  detachEventCheck()
  /// #if useOkta !== true
  api.EXTEND_WEB_USER_SESSION(null, release)
  /// #endif
}

const handleAuthTimeout = () => {
  store.dispatch(setExpiration(30))
}

const handleUserAction = () => {
  // console.log("Handled user action")
  detachEventCheck()
  store.dispatch(extendUserSession())
}

export const detachEventCheck = () => {
  document.removeEventListener('click', handleUserAction)
  document.removeEventListener('keydown', handleUserAction)
  document.removeEventListener('mousemove', handleUserAction)
}

export const attachEventCheck = () => {
  // console.log("Started listening");
  document.addEventListener('click', handleUserAction)
  document.addEventListener('keydown', handleUserAction)
  document.addEventListener('mousemove', handleUserAction)
}

const setAuthTimers = (paddedTimeout, eventCheckTimeout) => {
  store.dispatch(setExpiration(null))
  clearTimeout(window.AUTH_TIMER)
  clearTimeout(window.EVENT_CHECK_TIMER)
  window.AUTH_TIMER = window.setTimeout(handleAuthTimeout, paddedTimeout)
  if (eventCheckTimeout > 0) {
    window.EVENT_CHECK_TIMER = window.setTimeout(attachEventCheck, eventCheckTimeout)
  }
  localStorage.setItem('AUTH_TIMEOUT', paddedTimeout)
  store.dispatch(setAuthTimeoutExpiresAt(Date.now() + paddedTimeout))
}

export const setAuthTimeout = (timeout) => {
  const paddedTimeout = timeout - 60000
  const eventCheckTimeout = paddedTimeout - AUTH_EXTEND_THRESHOLD_MS
  // console.log("Timeout got set", paddedTimeout, eventCheckTimeout);
  if (paddedTimeout > 0) {
    setAuthTimers(paddedTimeout, eventCheckTimeout)
    ls.set('EVENT_SET_TIMEOUT', { paddedTimeout, eventCheckTimeout, trigger: shortid.generate() })
  }
}

ls.on('EVENT_SET_TIMEOUT', (value) => {
  // console.log(Date.now(), "Synced timeout");
  detachEventCheck()
  setAuthTimers(value.paddedTimeout, value.eventCheckTimeout)
})

ls.on('EVENT_LOGIN', (value) => {
  // console.log(Date.now(), "Synced login", value);
  store.dispatch(spreadAuthAttributes(value))
})

ls.on('EVENT_LOGOUT', () => {
  // console.log(Date.now(), "Synced logout");
  detachEventCheck()
  clearLocalUserState()
})

export const skipAuthCheck = () => (dispatch) => {
  dispatch(
    spreadAuthAttributes({
      initialAuthCheck: false,
    })
  )
}


// WEBPACK FOOTER //
// ./src/Auth/AuthActions.js